import { VehicleImagePreview } from "@/components/dailyCommute/VehicleImagePreview";
import { RouteEstimatePreview } from "@/components/dailyCommute/RouteEstimatePreview";
import type { RouteEstimate } from "@/services/googleDirectionsService";
import type { FuelType } from "@/types/fareCalculation";

interface RouteSummaryCardProps {
  fromAddress: string;
  toAddress: string;
  make?: string;
  model?: string;
  fuelType: FuelType;
  seats: number;
  routeEstimate?: RouteEstimate | null;
  routeEstimateLoading?: boolean;
}

export function RouteSummaryCard({
  fromAddress,
  toAddress,
  make,
  model,
  fuelType,
  seats,
  routeEstimate,
  routeEstimateLoading = false,
}: RouteSummaryCardProps) {
  return (
    <div className="rounded-xl border border-border/70 bg-muted/40 p-4">
      <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        Trip summary
      </p>
      <div className="grid gap-4 sm:grid-cols-[1fr_auto]">
        <div className="space-y-2.5 text-sm">
          <p className="flex items-start gap-2.5">
            <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary/10 text-[10px] font-bold text-primary">
              A
            </span>
            <span className="min-w-0 break-words">{fromAddress}</span>
          </p>
          <p className="flex items-start gap-2.5">
            <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary/10 text-[10px] font-bold text-primary">
              B
            </span>
            <span className="min-w-0 break-words">{toAddress}</span>
          </p>
          <div className="flex flex-wrap gap-2 pt-1">
            {make && (
              <span className="rounded-full bg-background px-2.5 py-1 text-xs font-medium ring-1 ring-border/60">
                {make}
              </span>
            )}
            {model && (
              <span className="rounded-full bg-background px-2.5 py-1 text-xs font-medium ring-1 ring-border/60">
                {model}
              </span>
            )}
            <span className="rounded-full bg-background px-2.5 py-1 text-xs font-medium ring-1 ring-border/60">
              {fuelType}
            </span>
            <span className="rounded-full bg-background px-2.5 py-1 text-xs font-medium ring-1 ring-border/60">
              {seats} seat{seats !== 1 ? "s" : ""}
            </span>
          </div>
          {(routeEstimateLoading || routeEstimate) && (
            <div className="pt-2">
              <RouteEstimatePreview
                estimate={routeEstimate}
                isLoading={routeEstimateLoading}
                compact
              />
            </div>
          )}
        </div>
        {make && model && (
          <VehicleImagePreview make={make} model={model} compact className="w-full sm:w-36" />
        )}
      </div>
    </div>
  );
}
